export const salesMenus = () => ({
    id: `main-menu-2-all`,
    path: '/management/sales/leads',
    label: 'Sales',
    isEnabled: true,
    svg: (
        <svg className="h-6 w-6 mr-1" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
            <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
            <g id="SVGRepo_iconCarrier">
                <path fill="#ffffff" fillRule="evenodd" clipRule="evenodd" d="M5 10.5a.5.5 0 0 1 .5-.5H7v-3a.5.5 0 0 1 .5-.5h9a.5.5 0 0 1 .5.5v3h1.5a.5.5 0 0 1 .5.5v9a.5.5 0 0 1-.5.5H5.5a.5.5 0 0 1-.5-.5v-9zm9-5a3.5 3.5 0 0 1 0 7 3.5 3.5 0 0 1 0-7zm-6 9h8v-2H8v2zm0 3h8v-2H8v2z" />
            </g>
        </svg>

    ),

    Description: 'Sales encompass a wide range of operations and activities aimed at effectively promoting, marketing, and selling goods or services to customers, ensuring business growth and customer satisfaction.',
    subMenu: [
        {
            id: `coln-1-collections`,
            label: 'Customers',
            svg: (
                <svg className="h-5 w-5 mr-1" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path fill="#007BFF" d="M12 2a5 5 0 0 0-5 5v1a5 5 0 0 0 5 5 5 5 0 0 0 5-5V7a5 5 0 0 0-5-5zm-1 6a1 1 0 1 1 2 0 1 1 0 0 1-2 0zM4 14a8 8 0 0 0 16 0H4zm0 2a6 6 0 0 1 12 0H4z" />
                </svg>

            ),
            path: '/management/sales/crm/customers',
            isEnabled: true,

        },
        {
            id: `coln-1-collections`,
            label: 'Leads',
            svg: (
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" className="h-4 w-4 mr-1" fill="#007BFF">
                    <path d="M12 0c-6.627 0-12 5.373-12 12s5.373 12 12 12 12-5.373 12-12S18.627 0 12 0zm0 22c-5.524 0-10-4.476-10-10S6.476 2 12 2s10 4.476 10 10-4.476 10-10 10zm-1-15h-2v2h2v-2zm0 4h-2v2h2v-2zm5 1h-2v2h2v-2zm2-4h-2v2h2V8zm-3 7h-2v2h2v-2zM8 12H6v2h2v-2z" />
                </svg>

            ),
            path: '/management/sales/leads',
            isEnabled: true,

        },
        {
            id: `coln-1-Categories`,
            label: 'Quotes',
            svg: (
                <svg className="h-5 w-5 mr-1" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path fill="#007BFF" d="M4 4v4h4V4H4zm0 6v4h4v-4H4zm6-6v4h4V4h-4zm0 6v4h4v-4h-4zm6-6v4h4V4h-4zm0 6v4h4v-4h-4z" />
                </svg>

            ),
            path: '/management/sales/quotes',
            isEnabled: true,
        },
        {
            id: `coln-1-Products`,
            label: 'Orders',
            svg: (
                <svg className="h-5 w-5 mr-1" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path fill="#007BFF" d="M4 2h16a1 1 0 0 1 1 1v14a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V3a1 1 0 0 1 1-1zm0 2v14h16V4H4zm2 2h12v2H6V6zm0 4h12v2H6v-2zm0 4h12v2H6v-2z" />
                </svg>

            ),
            path: '/management/sales/orders',
            isEnabled: true,
        },


    ],
}
)
